export default "__VITE_ASSET__6c9f6f2e__"